import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Notice } from '../models/notices.model';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})

export class NoticesService {
  baseUrl = `${environment.apiUrl}`;
  simulateUrl = `${environment.apiUrlSimulate}`;
  simulatePath = 'simulate';
  siriUrl = `${environment.apiSiriUrl}`;

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  getNotices(): Observable<Notice[]> {
    if (this.router.url.includes(this.simulatePath)) {
      //TODO: PONER LA DIRECCION CORRECTA
      return this.http.get<Notice[]>(`https://avsa-appreg.softoursistemas.com:42102/api/Avisos/getAvisos?numempre=1&codlinea=329`,{}).pipe(map((res) => res));
      // return this.http.get<Notice[]>(`${this.simulateUrl}/Avisos/getAvisosHoy?numempre=${numempre}&c_conces=${c_conces}&codlinea=${codlinea}`, {}).pipe(map((res)=>res));
      // getAvisos o AvisosLineasHoy?? declarar les variables
    } else {
      return this.http.get<Notice[]>(`https://avsa-appreg.softoursistemas.com:42102/api/Avisos/getAvisos?numempre=2&codlinea=401`,{}).pipe(map((res) => res));
      // return this.http.get<Notice[]>(`${this.baseUrl}/Avisos/getAvisosHoy?numempre=${numempre}&c_conces=${c_conces}&codlinea=${codlinea}`, {}).pipe(map((res)=>res));

    }

  }

}
